// extracted by mini-css-extract-plugin
module.exports = {"links":"EnergyLabelDrawer_links__omu4l","linkDetails":"EnergyLabelDrawer_linkDetails__ltpqd","energyLabel":"EnergyLabelDrawer_energyLabel__Uv_NL"};